export default [
    // empleado
    {
        path: "/list-solicitud-aumento-salario",
        name: "ListadosSolicitudesEmpleadosView",
        component: () => import(/* webpackChunkName: "perfil" */ "./empleado/views/ListadosSolicitudesEmpleadosView.vue")
    },
    {
        path: "/solicitud-aumento-salario",
        name: "NuevaSolicitudSalarialView",
        component: () => import(/* webpackChunkName: "perfil" */ "./empleado/views/NuevaSolicitudSalarialView.vue")
    },
    {
      path: "/ver-solicitud-aumento-salario/:id_solicitud_aumento_salarial/:id_empleado_puesto",
      name: "VerSolicitudSalarial",
      component: () => import(/* webpackChunkName: "perfil" */ "./empleado/views/NuevaSolicitudSalarialView.vue")
    },

    // jefe
    {
        path: "/list-solicitudes-aumento-salarial",
        name: "listSolicitudAumentoJefeUnidad",
        component: () => import(/* webpackChunkName: "perfil" */ "./jefeUnidad/views/listSolicitudesJefeUnidadView.vue")
    },
    {
        path: "/list-solicitudes-aumento-salarial/nueva-solicitud",
        name: "nueva-solicitud",
        component: () => import(/* webpackChunkName: "perfil" */ "./jefeUnidad/components/AddSolicitudAumentoSalario.vue")
    },
    {
        path: "/list-solicitudes-aumento-salarial/:id_solicitud_aumento_salarial/:id_empleado_puesto",
        name: "detalle-empleado",
        component: () => import(/* webpackChunkName: "perfil" */ "./jefeUnidad/components/verDetalleEmleado.vue")
    },

    // titular
    {
        path: "/list-solicitudes-aumento-salarial-unidades",
        name: "listSolicitudAumentoTitular",
        component: () => import(/* webpackChunkName: "perfil" */ "./titular/views/listSolicitudesTitularView.vue")
    },
    {
        path: "/detalle-solicitud-aumento-salarial/preliminar/:id",
        name: "detalleSolicitudAumentoPreliminar",
        component: () => import(/* webpackChunkName: "perfil" */ "./titular/views/detalleSolicitudPreliminarView.vue")
    },
    {
        path: "/detalle-solicitud-aumento-salarial/pendiente/:id",
        name: "detalleSolicitudAumentoPendiente",
        component: () => import(/* webpackChunkName: "perfil" */ "./titular/views/newDetalleSolicitudPendienteView.vue"),
        meta: { step: 7 }
    },

    // subtitular
    // {
    //     path: "/list-solicitudes-aumento-salarial-subtitular",
    //     name: "listSolicitudAumentoSubtitular",
    //     component: () => import(/* webpackChunkName: "perfil" */ "./subTitular/views/listSolicitudesSubtitularView.vue")
    // },
    // {
    //     path: "/detalle-solicitud-aumento-salarial-subtitular/preliminar/:id",
    //     name: "detalleSolicitudAumentoPreliminarSubtitular",
    //     component: () => import(/* webpackChunkName: "perfil" */ "./subTitular/views/detalleSolicitudPreliminarView.vue")
    // },
    // {
    //     path: "/detalle-solicitud-aumento-salarial-subtitular/acuerdo/:id",
    //     name: "detalleSolicitudAumentoPendienteSubtitular",
    //     component: () => import(/* webpackChunkName: "perfil" */ "./subTitular/views/detalleSolicitudPendienteView.vue"),
    //     meta: { step: 7 }
    // },

    // RRHH
    {
        path: "/list-solicitudes-aumento-salarial-rh",
        name: "listSolicitudAumentoRh",
        component: () => import(/* webpackChunkName: "perfil" */ "./rrhh/views/listSolicitudesRh.vue")
    },
    {
        path: "/list-solicitudes-aumento-salarial/asignacion-salario/:id",
        name: "asignacion-nuevo-salario",
        component: () => import(/* webpackChunkName: "perfil" */ "./rrhh/components/asignacionSalario.vue")
    },
    {
        path: "/list-solicitudes-aumento-salarial-rh/asignacion-salario/:id",
        name: "VerDetalleSolicitudes",
        component: () => import(/* webpackChunkName: "perfil" */ "./rrhh/components/verDetalleSolicitudes.vue")
    },
    {
        path: "/list-solicitudes-aumento-salarial-rh-aprobadas/asignacion-salario/:id",
        name: "VerDetalleSolicitudAprobada",
        component: () => import(/* webpackChunkName: "perfil" */ "./rrhh/components/verDetalleSolicitudAprobada.vue")
    },
    {
        path: "/detalle-solicitud-aprobada-rh/:id",
        name: "detalleSolicitudAprobadaRH",
        component: () => import(/* webpackChunkName: "perfil" */ "./titular/views/detalleSolicitudPendienteView.vue"),
        meta: { step: 6 }
    },

    // Ufi
    {
        path: "/list-solicitudes-aumento-salarial-ufi",
        name: "list-solicitudes-ufi",
        component: () => import(/* webpackChunkName: "perfil" */ "./ufi/views/listUfi.vue")
    },
    {
        path: "/list-solicitudes-aumento-salarial-ufi/:id",
        name: "list-solicitudes",
        component: () => import(/* webpackChunkName: "perfil" */ "./ufi/components/verSolicitudUfi.vue")
    },
    {
        path: "/detalle-solicitud-aprobada-ufi/:id",
        name: "detalleSolicitudAprobadaUFI",
        component: () => import(/* webpackChunkName: "perfil" */ "./titular/views/detalleSolicitudPendienteView.vue"),
        meta: { step: 5 }
    },

    // Entidad superior
    {
      path: "/list-solicitudes-aumento-salarial-entidad-superior",
      name: "ListadosSolicitudesEntidadSuperiorView",
      component: () => import(/* webpackChunkName: "perfil" */ "./entidad-superior/views/ListadosSolicitudesEntidadSuperiorView.vue")
    },
]